import React from 'react';

import ProjectInteriorPages from '../../../../components/project/project-interior-pages';
import ProjectSlider from '../../../../components/project/project-slider';
import ProjectMarketingTiles from '../../../../components/project/project-marketing-tiles';
import ProjectBrandedMaterials from '../../../../components/project/project-branded-materials';
import ProjectDesignElement from '../../../../components/project/project-design-element';
import ProjectQuote from '../../../../components/project/project-quote';
import Reveal from '../../../../components/reveal';

const PhilipsCaseStudy = ({ acf }) => {
  return (
    <React.Fragment>
      <ProjectInteriorPages
        images={acf.interior_pages}
        blurb={acf.interior_pages_blurb}
        wrapperPadding={'0'}
      />
      <ProjectSlider
        slides={acf.slider}
        blurb={acf.slider_blurb}
        wrapperPadding={[
          'calc(10vw - 14px) 10vw 10vw 10vw',
          'calc(10vw - 14px) 0 10vw 0',
        ]}
      />
      <ProjectBrandedMaterials
        image={acf.branded_materials_image}
        blurb={acf.branded_materials_blurb}
        wrapperPadding={'0'}
      />

      <ProjectDesignElement
        image={acf.design_element_image}
        blurb={acf.design_element_blurb}
        wrapperPadding={'10vw 0 10vw 0'}
      />

      <ProjectMarketingTiles
        images={acf.marketing_tiles}
        blurb={acf.marketing_tiles_blurb}
        wrapperPadding={'0 0 3vw 0'}
      />
      <ProjectQuote
        quote={acf.quote}
        name={acf.quote_name}
        title={acf.quote_title}
      />
    </React.Fragment>
  );
};

export default PhilipsCaseStudy;



// WEBPACK FOOTER //
// ./src/templates/project/case-studies/philips/index.js